export default "__VITE_ASSET__DtT_KqKe__"